import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

export interface VehiculoFrecuenteItem {
  id: number;
  descripcion: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string;
}

@Injectable({
  providedIn: "root",
})
export class VehiculoFrecuenteService {
  private apiUrl = `${environment.apiUrl}/api/vehiculo_frecuente`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<VehiculoFrecuenteItem[] | { vehiculosFrecuentes?: VehiculoFrecuenteItem[] }> {
    return this.http.get<VehiculoFrecuenteItem[] | { vehiculosFrecuentes?: VehiculoFrecuenteItem[] }>(this.apiUrl, {
      withCredentials: true,
    });
  }
}
